var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ev-charging-history" }, [
      _c("div", [
        _c("div", [
          _c("div", { attrs: { id: "ev-charging-history-chart-container" } })
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }